import { Box, Center, Heading } from "@chakra-ui/react";
import CourtSelector from "./CourtSelector";
import Header from "./Header";
import { Wizard } from "react-use-wizard";
import { StateProvider } from "./state";
import Verification from "./Verification";
import Settings from "./Settings";
import { StartLiveRecordingRequest } from "proto/recording/v1/recording_api_pb";
import CameraSelect from "./Camera";

export default function LiveRecording() {
  return (
    <StateProvider
      initialState={{
        request: new StartLiveRecordingRequest(),
      }}
    >
      <Box mt={[10, 2]} mx={{ base: 2, md: 4, lg: 8 }}>
        <Center>
          <Box w="90%" textAlign={"center"}>
            <Heading size={"xl"}>Start Match</Heading>
          </Box>
        </Center>
        <Wizard header={<Header />} startIndex={0}>
          <CameraSelect />
          <CourtSelector />
          <Verification />
          <Settings />
        </Wizard>
      </Box>
    </StateProvider>
  );
}
